import { render, staticRenderFns } from "./VocabularyTop.vue?vue&type=template&id=231290a1&scoped=true&lang=pug"
import script from "./VocabularyTop.vue?vue&type=script&lang=ts"
export * from "./VocabularyTop.vue?vue&type=script&lang=ts"
import style0 from "./VocabularyTop.vue?vue&type=style&index=0&id=231290a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231290a1",
  null
  
)

export default component.exports